const Button = ({text, onClick, small}) => {
    const textStyle = small ? 'py-2 px-4 font-medium text-xl text-white' : 'py-2 px-4 font-medium text-3xl text-white'
    return (
        <div className="bg-orange-500 rounded-lg hover:opacity-70 cursor-pointer flex justify-center items-center" onClick={onClick}>
            <p className={textStyle}>{text}</p>
        </div>
    )
}

export default Button